// Import the functions you need from the Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth"; // Updated to use signInWithPopup for better compatibility

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCWGgURALM75_kv9QmlnWFue82LxKNps_I",
  authDomain: "walkupp-web-aca01.firebaseapp.com",
  projectId: "walkupp-web-aca01",
  storageBucket: "walkupp-web-aca01.appspot.com",
  messagingSenderId: "681168975733",
  appId: "1:681168975733:web:5b67b484dafb946467053c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Google Auth Provider
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Export the Firebase authentication objects
export { auth, googleProvider, signInWithPopup };
